<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- رأس الصفحة (تم تحديثه لعرض البيانات الجديدة) -->
    <div class="card shadow-sm border-0 mb-4 bg-light">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center">
          
          <!-- بيانات الطالب -->
          <div v-if="subjectInfo" class="d-flex align-items-center gap-4">
            <!-- الصورة الرمزية (اختياري) -->
            <div class="bg-white p-3 rounded-circle shadow-sm text-primary">
              <i class="fas fa-user-graduate fa-2x"></i>
            </div>
            
            <div>
              <h4 class="fw-bold text-dark mb-1">{{ subjectInfo.student_name }}</h4>
              <div class="d-flex gap-3 text-muted small">
                <span class="badge bg-primary text-white fs-6">
                  <i class="fas fa-id-card ms-1"></i> جلوس: {{ subjectInfo.seating_no }}
                </span>
                <span class="badge bg-dark text-warning fs-6">
                  <i class="fas fa-key ms-1"></i> سري: {{ subjectInfo.secret_number }}
                </span>
                <span class="badge bg-success text-white fs-6">
                  <i class="fas fa-star ms-1"></i> الدرجة: {{ subjectInfo.degree }}
                </span>
              </div>
              <div class="mt-2 text-primary fw-bold">
                 <i class="fas fa-book-open ms-1"></i> المادة: {{ subjectInfo.subject_name }}
              </div>
            </div>
          </div>

          <!-- حالة التحميل -->
          <div v-else class="text-muted">
            <span class="spinner-border spinner-border-sm ms-2"></span> جاري تحميل البيانات...
          </div>

          <!-- الأزرار -->
          <div class="d-flex gap-2">
            <button @click="openScanner" class="btn btn-outline-primary fw-bold shadow-sm">
              <i class="fas fa-camera ms-2"></i> إضافة صفحات
            </button>
            <button @click="approvePaper" class="btn btn-success fw-bold px-4 shadow-sm">
              <i class="fas fa-check-double ms-2"></i> اعتماد وإنهاء
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- شبكة الصور (Gallery) - كما هي -->
    <div class="row g-3" v-if="images.length > 0">
      <div v-for="(img, index) in images" :key="img.id" class="col-md-4 col-lg-3">
        <div class="card h-100 shadow-sm border-0 position-relative image-card">
          
          <div class="ratio ratio-4x3 bg-light cursor-pointer" @click="previewImage(img.url)">
            <img :src="img.url" class="object-fit-contain rounded-top">
          </div>

          <div class="card-body p-2 d-flex justify-content-between align-items-center bg-white rounded-bottom">
            <span class="badge bg-secondary">صفحة {{ index + 1 }}</span>
            <button @click="deleteImage(img.id, index)" class="btn btn-sm btn-outline-danger" title="حذف">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>

          <div class="overlay" @click="previewImage(img.url)">
            <i class="fas fa-search-plus fa-2x text-white"></i>
          </div>

        </div>
      </div>
    </div>

    <!-- حالة فارغة -->
    <div v-else class="text-center py-5 text-muted bg-white rounded border border-dashed shadow-sm">
      <i class="fas fa-images fa-3x mb-3 opacity-25"></i>
      <h5>لا توجد صور لهذه المادة حتى الآن</h5>
      <button @click="openScanner" class="btn btn-primary mt-3 px-4 rounded-pill">
         <i class="fas fa-camera me-2"></i> رفع صور الآن
      </button>
    </div>

    <!-- Modal: عارض الصور (Lightbox) - كما هو -->
    <div v-if="showPreview" class="modal-backdrop fade show" style="background: rgba(0,0,0,0.9);"></div>
    <div v-if="showPreview" class="modal fade show d-block" tabindex="-1" @click.self="closePreview">
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content bg-transparent border-0 shadow-none">
          <div class="modal-body d-flex justify-content-center align-items-center position-relative">
            <button class="btn btn-light position-absolute top-0 end-0 m-4 rounded-circle shadow" @click="closePreview">
              <i class="fas fa-times fa-lg"></i>
            </button>
            <img :src="previewUrl" class="img-fluid rounded shadow-lg" style="max-height: 90vh;">
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: الكاميرا - كما هو -->
    <div v-if="showScanner" class="modal fade show d-block" style="background: rgba(0,0,0,0.8);">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content bg-dark border-0">
                <div class="modal-header border-0">
                    <h5 class="text-white"><i class="fas fa-camera ms-2"></i> إضافة صفحات للمادة</h5>
                    <button class="btn-close btn-close-white" @click="showScanner = false"></button>
                </div>
                <div class="modal-body p-0">
                    <MultiPageScanner 
                        :subjectId="subjectId" 
                        @upload-success="handleUploadSuccess"
                    />
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';
import MultiPageScanner from './MultiPageScanner.vue';

export default {
  name: "PaperQualityReview",
  components: { MultiPageScanner },
  props: ['subjectId'],
  data() {
    return {
      images: [],
      // سيتم تعبئة هذا الكائن من الباك إند
      subjectInfo: null, 
      showPreview: false,
      previewUrl: '',
      showScanner: false
    };
  },
  mounted() {
    this.fetchImages();
  },
  methods: {
    async fetchImages() {
      try {
        const res = await api.get(`/appeals/edit-images/${this.subjectId}`);
        this.images = res.data.images;
        
        // هنا نستقبل البيانات الجديدة من الباك إند
        this.subjectInfo = {
            student_name: res.data.student_name,
            subject_name: res.data.subject_name,
            seating_no: res.data.seating_no,     // جديد
            secret_number: res.data.secret_number, // جديد
            degree: res.data.degree              // جديد
        };
      } catch (e) {
        console.error(e);
        alert("حدث خطأ أثناء جلب البيانات");
      }
    },

    async deleteImage(id, index) {
      if(!confirm("هل أنت متأكد من حذف هذه الصفحة؟")) return;
      try {
        await api.delete(`/appeals/images/${id}`);
        this.images.splice(index, 1);
      } catch (e) {
        alert("فشل الحذف");
      }
    },

    openScanner() {
      this.showScanner = true;
    },

    handleUploadSuccess() {
      this.showScanner = false;
      this.fetchImages();
      // يمكنك إضافة إشعار نجاح هنا
    },

    approvePaper() {
      if(this.images.length === 0) return alert("لا توجد صور لاعتمادها!");
      // هنا كود الاعتماد (تغيير الحالة في الباك اند)
      alert("تم اعتماد الورقة وأصبحت متاحة للطالب.");
      this.$router.go(-1);
    },

    previewImage(url) {
      this.previewUrl = url;
      this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
    }
  }
};
</script>

<style scoped>
.image-card {
  transition: transform 0.2s, box-shadow 0.2s;
  overflow: hidden;
  border: 1px solid #eee !important;
}
.image-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
  border-color: #0d6efd !important;
}

.overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 42px; /* يترك مساحة لأزرار التحكم السفلية */
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s;
  cursor: zoom-in;
  border-radius: 5px 5px 0 0;
}
.image-card:hover .overlay {
  opacity: 1;
}

.cursor-pointer { cursor: pointer; }
</style>